define('ScrollSpy',['jquery'], function ($) {

  var TopPadding = 65;
  var data = $('[data-nav-scroll]');
  var menu = $('.navigation-spy');
  var maxTextLenght = 33;
  var menuItemTemplate = "<li class='spot-link'><a href='#'>{{text}}</a></li>";
  var activeElement;
  // Empty the menu
  if(data.length > 0 && menu.length > 0) {
      menu.html('');
      // Build menu
      data.each(function() {
          var elm = $(this);
          var text = $(elm).attr("data-nav-scroll") != '' ? $(elm).attr("data-nav-scroll") : elm.text();
          if(text.length > maxTextLenght) {
             text = text.substring(0, text.lastIndexOf(" ", maxTextLenght)) + " …";
          }
          $(menuItemTemplate.replace("{{text}}", text)).appendTo(menu);
          menu.css({ "margin-top": -menu.outerHeight(true) });
      });

      menu.find('a').click(function(e) {
          var curr = $(this),
              offsetTop = data[curr.closest('li').index()].offsetTop - TopPadding;
          $('html, body').stop().animate({
              scrollTop: offsetTop,
              easing: "swing"
          }, 400);

          e.preventDefault();
      });

      // Interact when scrolling
      $(window).scroll(function(){
         var fromTop = $(this).scrollTop()+parseInt(TopPadding)+10;
         var cur = data.map(function(){
              if ($(this).offset().top < fromTop) {
                return this;
              }
         });
        
        if(cur[cur.length-1] != null || cur[cur.length-1] != undefined) {
            menu.children('li')  
              .removeClass("active")
              .filter(":contains('"+cur[cur.length-1].textContent.substring(0, cur[cur.length-1].textContent.lastIndexOf(" ", maxTextLenght))+"'), :contains('"+$(cur[cur.length-1]).attr("data-nav-scroll").substring(0, $(cur[cur.length-1]).attr("data-nav-scroll").lastIndexOf(" ", maxTextLenght))+"')").addClass("active");
        }

        // when hits bottom of page, sets last menu active.           
        if($(window).scrollTop() + $(window).height() === $(document).height()){
            menu.children('li')  
              .removeClass("active")
              .last().addClass("active");
        }

      });
  }
});
